<span>{{ selectedTimeZoneValue() }}</span>
